import { AccountDto } from '@services/api'
import { Actions } from '@state/actions'
import { doGetMemberPreferences } from '@state/reducers/memberPreferencesReducer'
import { useSelector } from '@state/store'
import { findMyInfos } from '@state/thunks/authThunk'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

export default function ShellReportLayout() {
  const dispatch = useDispatch()
  const { isAuth } = useSelector(({ auth }) => ({
    isAuth: auth.isAuth,
    account: auth.account as AccountDto,
  }))

  useEffect(() => {
    if (isAuth) {
      dispatch(findMyInfos())
      dispatch(doGetMemberPreferences())
    }
  }, [dispatch, isAuth])

  if (!isAuth) return <Navigate to={{ pathname: '/auth/login' }} />

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
      }}
    >
      <Outlet />
    </div>
  )
}